module.exports = __webpack_public_path__ + "img/77.10.pH.27a3b4a9.png";